import { render, staticRenderFns } from "./MediaItems.vue?vue&type=template&id=54dfba20&scoped=true&"
import script from "./MediaItems.vue?vue&type=script&lang=js&"
export * from "./MediaItems.vue?vue&type=script&lang=js&"
import style0 from "./MediaItems.vue?vue&type=style&index=0&id=54dfba20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfba20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VFileInput,VIcon})
